type OpcValues = {
    opcHost?: string;
    opcUsername?: string;
    opcPassword?: string;
};

type CustomerData = {
    description: string;
    maxUsers: number;
    defaultMaxWbsLevel: number;
    confetti: boolean;
    aiType: string;
};

type BuildCustomerPayloadParams = {
    customerId: number;
    customerData?: CustomerData;
    opcValues?: OpcValues;
};

export function buildCustomerPayload({ customerId, customerData = {}, opcValues = {} }: BuildCustomerPayloadParams) {
    return {
        id: customerId,
        //OPC Values
        opcHost: opcValues.opcHost ?? '',
        opcUsername: opcValues.opcUsername ?? '',
        opcPassword: opcValues.opcPassword ?? '',
        //Customer Values
        description: customerData.description ?? '',
        maxUsers: customerData.maxUsers,
        maxWbsLevel: customerData.defaultMaxWbsLevel,
        confettiON: Boolean(customerData.confetti),
        aiType: customerData.aiType,
        name: customerData.description ?? '',
    };
}
